import React, { Component, PropTypes } from 'react';
import { withRouter, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import Dropzone from 'react-dropzone'
import { uploadImage } from '../lib/upload'
import { setOverlay, clearOverlayErrors, authInfo } from '../actions';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import Alert from '../components/home/Alert';
import _ from 'lodash';

 const propTypes = {
  dispatch: PropTypes.func,
  isAuthenticated: PropTypes.bool,
  overlay: PropTypes.object,
  error: PropTypes.any,
}

const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}

const clientOptions = {
  sessionCache: true
}

const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)
 class OverlaysNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: !props.isAuthenticated,
      alertOpen: false,
      alertMessage: '',
      error: false,
      required: {
        id: 1,
        altTxt: '',
        category:'',
        width: 1,
        height: 1,
        swatch: '',
        overlayWhite: '',
        overlayBlack: '',
        disabled: true
      },
      overlay: {
        id: 1,
        altTxt: '',
        category:'',
        width: 1,
        height: 1,
        swatch: '',
        overlayWhite: '',
        overlayBlack: '',
        disabled: true
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.goBack();
    }
    this.setRequiredParams();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        error: true,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
      });
    }
    if (nextProps.overlay && !nextProps.error) {
      this.setState({
        alertOpen: true,
        error: false,
        alertMessage: 'Overlay saved successfully!',
      });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const { required, overlay } = this.state
    Object.keys(required).forEach((paramName) => {
      const param = overlay[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleChange(e) {
    const nextState = this.state.overlay
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked)
    } else {
      _.set(nextState, e.target.name, e.target.value)
    }
    this.setState({
      overlay: nextState,
    })
    this.setRequiredParams()
  }
  handleSubmit() {
    this.props.dispatch(clearOverlayErrors());
    const pOverlay = this.state.overlay;
    console.log('OVERLAY IN STATE', pOverlay)
    this.props.dispatch(setOverlay(pOverlay));
  }
  handleCancel() {
    this.props.dispatch(clearOverlayErrors());
    browserHistory.push('/overlays');
  }
  alertHandleClose() {
    this.setState({
      alertMessage: '',
      alertOpen: false,
    });
    if (!this.state.error) {
      browserHistory.push('/overlays');
    }
  }
  handleUploadedImage(name, value) {
    const nextState = this.state.overlay;
    _.set(nextState, name, value)
    this.setState({
      overlay: nextState,
      edited: true,
    });
    this.setRequiredParams()
  }
  onDrop(file, bucket, name, handleChangeOption) {
    console.log('FILE', file)
    const { dispatch } = this.props
    console.log('# New file for bucket: ', bucket);
    console.log('# dispatching uploadImage...');
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        console.log('response***', response)
        handleChangeOption({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        //alert(`Image upload failed: ${err}`);
        return '';
      });
  }
  render() {
    const { overlay, required } = this.state
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      inputStyleLarge: {
        marginRight: '2%',
        width: '50vw',
      }
    };
    return (
      <div className="overlays component" style={authPage}>
        <h2>New Overlay</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <div className="float-right">
            <RaisedButton
              label="Cancel"
              style={{ margin: '20px' }}
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Save"
              primary
              onClick={this.handleSubmit}
            />
          </div>
          <br />
          <br />
          <div>
          <TextField
              floatingLabelText="Overlay ID"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.id}
              name="id"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.id}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <br /><br />
            <TextField
              floatingLabelText="Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.altTxt}
              name="altTxt"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.altTxt}
              errorStyle={{ color: cyan500 }}
            />
            <TextField
              floatingLabelText="Category"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.category}
              name="category"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.category}
              errorStyle={{ color: cyan500 }}
            />
            <br /><br />
            <TextField
              floatingLabelText="Width"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.width}
              name="width"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.width}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <TextField
              floatingLabelText="Height"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.height}
              name="height"
              onChange={this.handleChange}
              style={styles.inputStyle}
              errorText={required.height}
              errorStyle={{ color: cyan500 }}
              type="number"
            />
            <br /><br />
            <TextField
              floatingLabelText="White Overlay URL"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.overlayWhite}
              name="overlayWhite"
              onChange={this.handleChange}
              style={styles.inputStyleLarge}
              errorText={required.overlayWhite}
              errorStyle={{ color: cyan500 }}
            />
            <Dropzone
              ref="dropzone"
              accept="image/jpeg, image/png, image/gif"
              style={dropzoneStyles}
              onDrop={(file) => this.onDrop(file, 'focus-product-images', "overlayWhite", this.handleChange)}
            >Upload White Overlay</Dropzone>
            <br /><br />
            <TextField
              floatingLabelText="Black Overlay URL"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.overlayBlack}
              name="overlayBlack"
              onChange={this.handleChange}
              style={styles.inputStyleLarge}
              errorText={required.overlayBlack}
              errorStyle={{ color: cyan500 }}
            />
            <Dropzone
              ref="dropzone"
              accept="image/jpeg, image/png, image/gif"
              style={dropzoneStyles}
              onDrop={(file) => this.onDrop(file, 'focus-product-images', "overlayBlack", this.handleChange)}
            >Upload Black Overlay</Dropzone>
            <br /><br />
            <TextField
              floatingLabelText="Swatch URL"
              floatingLabelStyle={styles.floatingLabelStyle}
              value={overlay.swatch}
              name="swatch"
              onChange={this.handleChange}
              style={styles.inputStyleLarge}
              errorStyle={{ color: cyan500 }}
            />
            <button
              className="filestack-button"
              onClick={(e) => {
                e.preventDefault;
                return client.picker({
                  uploadInBackground: false,
                  onUploadDone: ((res) => {
                    console.log('RES FROM FILESTACK', res);
                    const targetName = 'swatch'
                    const targetValue = res.filesUploaded[0].url
                    this.handleUploadedImage(targetName, targetValue)
                  })
                }).open()
              }}
              style={dropzoneStyles}>
              <p className="filestack-uplaod">UPLOAD SWATCH</p>
            </button>
            <br /><br /><br />
            <Checkbox
              label="Disabled"
              defaultChecked={overlay.disabled}
              name="disabled"
              onCheck={this.handleChange}
              />
          </div>
        </div>
      </div>
    );
  }
}
 OverlaysNewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};
 OverlaysNewPage.propTypes = propTypes;

 function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
}

 export default withRouter(connect(mapStateToProps)(OverlaysNewPage))


// WEBPACK FOOTER //
// ./src/containers/OverlaysNewPage.js